import { all, call, takeLatest, put } from "redux-saga/effects";
import {
    FETCH_REF_DOCTORS, FETCH_REF_DOCTORS_START, FETCH_REF_DOCTORS_SUCCESS,
    FETCH_REF_DOCTORS_ERROR, ADD_UPDATE_REF_DOCTOR, ADD_UPDATE_REF_DOCTOR_SUCCESS, ADD_UPDATE_REF_DOCTOR_START, ADD_UPDATE_REF_DOCTOR_ERROR, DELETE_REF_DOCTOR, DELETE_REF_DOCTOR_START, DELETE_REF_DOCTOR_SUCCESS, DELETE_REF_DOCTOR_ERROR, DELETE_PROVIDER_LOCATION, DELETE_PROVIDER_LOCATION_SUCCESS, DELETE_PROVIDER_LOCATION_ERROR, FETCH_ALL_REF_DOCTORS_START, FETCH_ALL_REF_DOCTORS_SUCCESS, FETCH_ALL_REF_DOCTORS_ERROR, FETCH_ALL_REF_DOCTORS, SET_REF_DOCTORS_PAGINATION
} from "../../actions/receptionist/refDoctorsAction";
import { message } from 'antd';
import { addUpdateRefDoctorAPI, deleteProviderLocationAPI, deleteRefDoctorAPI, fetchAllRefDoctorsAPI, fetchRefDoctorsAPI } from "../../../services/ref-doctors-service";
import _ from 'lodash';
import { HIDE_MODAL, SUBMIT_ERROR, SUBMIT_START } from "../../actions";

function* fetchRefDoctors({ payload }) {
    try {
        yield put({ type: FETCH_REF_DOCTORS_START })

        const response = yield call(fetchRefDoctorsAPI, payload);

        if (response.success) {
            const pagination = {
                currentPage: payload.page,
                pageSize: payload.size,
                totalPages: response.data.totalPages,
                totalItems: response.data.totalItems,
            }

            yield put({ type: FETCH_REF_DOCTORS_SUCCESS, refDoctors: response.data.referralDoctors.length > 0 ? [...response.data.referralDoctors] : [] });
            yield put({ type: SET_REF_DOCTORS_PAGINATION, pagination: pagination });

        } else {
            yield put({ type: FETCH_REF_DOCTORS_ERROR });
            message.error('Failed to fetch ref. doctors!');
        }
    } catch (error) {
        message.error('Failed to fetch ref. doctors!');
    }
}
function* addUpdateRefDoctor({ payload }) {
    try {
        yield put({ type: ADD_UPDATE_REF_DOCTOR_START })
        yield put({ type: SUBMIT_START });

        const response = yield call(addUpdateRefDoctorAPI, payload.doctor);
        if (response.success) {
            if (payload.doctor.id === 0) {
                message.success('Added ref doctor successfully.');
            } else {
                message.success('Updated ref doctor successfully.');
            }

            yield put({ type: HIDE_MODAL });
            yield put({ type: ADD_UPDATE_REF_DOCTOR_SUCCESS, refDoctor: _.cloneDeep(response.data) });

        } else {
            message.error('Failed to add ref doctor!');
            yield put({ type: SUBMIT_ERROR });
        }
    }
    catch (error) {
        yield put({ type: SUBMIT_ERROR });
        message.error('Failed to add referred doctor!');
    }
}

function* deleteRefDoctor({ payload }) {
    try {
        yield put({ type: DELETE_REF_DOCTOR_START })

        const response = yield call(deleteRefDoctorAPI, payload);
        if (response.success) {
            message.success('Deleted ref doctor successfully!');
            yield put({ type: DELETE_REF_DOCTOR_SUCCESS, refDrId: payload });

        } else {
            message.error('Failed to delete ref doctor!');
            yield put({ type: DELETE_REF_DOCTOR_ERROR });
        }

    }
    catch (error) {
        message.error('Failed to add referred doctor!');

    }
}

function* deleteProviderLocation({ payload }) {
    try {
        const response = yield call(deleteProviderLocationAPI, payload.providerLocationId);
        if (response.success) {
            message.success('Deleted provider location successfully!');
            yield put({ type: DELETE_PROVIDER_LOCATION_SUCCESS, refDoctor: _.cloneDeep(payload) });

        } else {
            message.error('Failed to delete provider location!');
            yield put({ type: DELETE_PROVIDER_LOCATION_ERROR });
        }
    }
    catch (error) {
        message.error('Failed to delete provider location!');

    }
}

function* fetchAllRefDoctors({ }) {
    try {
        yield put({ type: FETCH_ALL_REF_DOCTORS_START })
        const response = yield call(fetchAllRefDoctorsAPI);
        if (response.success) {
            yield put({ type: FETCH_ALL_REF_DOCTORS_SUCCESS, allRefDoctors: response.data.length > 0 ? [...response.data] : [] });
        } else {
            yield put({ type: FETCH_ALL_REF_DOCTORS_ERROR });
            message.error('Failed to fetch ref. doctors!');
        }
    } catch (error) {
        message.error('Failed to fetch ref. doctors!');
    }
}


function* refDoctorsWatcher() {
    yield takeLatest(FETCH_REF_DOCTORS, fetchRefDoctors)
    yield takeLatest(ADD_UPDATE_REF_DOCTOR, addUpdateRefDoctor)
    yield takeLatest(DELETE_REF_DOCTOR, deleteRefDoctor)
    yield takeLatest(DELETE_PROVIDER_LOCATION, deleteProviderLocation)
    yield takeLatest(FETCH_ALL_REF_DOCTORS, fetchAllRefDoctors)

}


export default function* rootSaga() {
    yield all([refDoctorsWatcher(),
    ])
}